import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Motion";
import { TierCard } from "@/components/TierCard";
import { Ribbon } from "@/components/Ribbon";
import { TIERS } from "@/lib/site";

const FAQ = [
  { q: "What happens in a consultation?", a: "Manny reviews your situation, diagnoses the real issue, and gives you a clear, honest plan with next steps you can take to any contractor of your choice." },
  { q: "Do you do the electrical work too?", a: "No — this is consulting only. You get Manny's independent, unbiased advice and a plan you fully own, with zero pressure to hire anyone in particular." },
  { q: "Can you help me weigh financing options?", a: "Yes. Manny can guide you toward programs like Go Green Financing for qualified energy-efficient upgrades, so you understand your options before you commit." },
  { q: "Are consults in person or virtual?", a: "Both. Residential and commercial consults can start virtually; industrial reviews are typically on-site. You'll pick a preferred time when you book." },
];

export default function Pricing() {
  return (
    <div>
      <PageHeader
        label="Pricing"
        titleLines={["Simple,", "By Tier"]}
        sub="No rigid hourly rates. Your consultation fee is reasonably priced according to each project — matched to the scope, complexity and audience of your work."
      />

      <section className="mx-auto max-w-[1400px] px-5 pb-8 md:px-10">
        <div className="grid gap-6 lg:grid-cols-3">
          {TIERS.map((t, i) => <TierCard key={t.id} tier={t} index={i} />)}
        </div>
        <Reveal delay={0.1}>
          <p className="mt-8 text-center text-sm text-white/40">
            Every consultation ends with a clear, actionable plan that's yours to keep — no obligation to hire.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-[1000px] px-5 py-24 md:px-10 md:py-32">
        <h2 className="font-head text-4xl font-medium tracking-tight text-white md:text-6xl">FAQ</h2>
        <div className="mt-10 divide-y divide-white/10 border-t border-white/10">
          {FAQ.map((f, i) => (
            <Reveal key={f.q} delay={i * 0.05}>
              <div className="grid gap-3 py-8 md:grid-cols-[0.9fr_1.1fr]">
                <h3 className="font-head text-2xl font-medium tracking-tight text-white">{f.q}</h3>
                <p className="leading-relaxed text-white/60">{f.a}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <Ribbon direction="right" />
    </div>
  );
}
